<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
		<path
			d="M4.02991 18H0.297321V5.98259H4.02991V18ZM2.16161 4.3433C0.968304 4.3433 0 3.35491 0 2.16161C0 1.58831 0.22774 1.0385 0.63312 0.63312C1.0385 0.22774 1.58831 0 2.16161 0C2.7349 0 3.28471 0.22774 3.69009 0.63312C4.09547 1.0385 4.32321 1.58831 4.32321 2.16161C4.32321 3.35491 3.35491 4.3433 2.16161 4.3433ZM17.996 18H14.2714V12.15C14.2714 10.7558 14.2433 8.96786 12.3308 8.96786C10.3902 8.96786 10.0929 10.4826 10.0929 12.0496V18H6.36429V5.98259H9.9442V7.62187H9.99643C10.4946 6.67768 11.7121 5.68125 13.5281 5.68125C17.3049 5.68125 18 8.1683 18 11.3987V18H17.996Z"
			fill="#7B7B7B"
		/>
	</svg>
</template>
